import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/css/icons.css';
import '../../assets/css/style.css'
import 'react-dropdown-tree-select/dist/styles.css'
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from '../../Server'
import swal from 'sweetalert';
import axios from 'axios';
import Chat from './Chat';
import allcontant from '../../../src/assets/images/allcontacts.png'
import favrouite from '../../../src/assets/images/favrouite.png'
import network from '../../../src/assets/images/network.png'

var socket;
export default function ContactList(props) {
    const [liveuser, setLiveuser] = useState([])
    const [liveuserids, setLiveuserids] = useState([])
    const [contact_list, setContactList] = useState([]);
    const [favourite_list, setFavourite_list] = useState([]);
    const [network_list, setNetwork_list] = useState([]);

    const [contact_filtered, setFilteredcontact] = useState([]);
    const [favourite_filtered, setFilteredfavourite] = useState([]);
    const [network_filtered, setFilterednetwork] = useState([]);
    
    const [favourite, setFavourite] = useState([]);
    const [minimizetabs, setMinimizetabs] = useState([]);
    const [messagecount, setMessagecount] = useState([]);
    const [modalshow, setModalshow] = useState([]);
    const [section, setSection] = useState({ allContact: true, favourite: false, myNetwork: false })
    const [view, setView] = useState({ block: true, list: false })
    const [infopopup, setInfopopup] = useState({ show: false, data: {} })

    const fetchContactList = () => {
        var data = {
            user_id: ud.id,
            datetime: ""
        }
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        axios.post(`${SERVER_IP}/usersContactList`, data, { withCredentials: true, headers: headers })
        .then(function (response) {
            if (response.data.status) {
                if (response.data.status.error === false) {
                    setContactList(response.data.contacts)
                    setFilteredcontact(response.data.contacts)
                    const newArr = [];
                    const favouriteArr = [];
                    const favouriteListArr = [];
                    response.data.contacts.forEach(element => {
                        element.favorite && favouriteArr.push(element.login_id)
                        element.favorite && favouriteListArr.push(element)
                        const obj = {
                            id: element.login_id,
                            show: false
                        }
                        newArr.push(obj)
                    });
                    setFavourite(favouriteArr)
                    setFavourite_list(favouriteListArr)
                    setFilteredfavourite(favouriteListArr)
                    setModalshow(newArr)
                }
            } else {
                if (response.data.error === true) {
                    auth_response_flow(response.data, (return_response) => {
                        if (return_response.error === false && return_response.retry === true) {
                            fetchContactList();
                        }
                    })
                }
            }
        }).catch(function (error) {
            swal("Something Went Wrong,Please Retry")
        });
    }

    const postFavourite = (fav_user_id) => {
        const isDelete = favourite.indexOf(fav_user_id)>-1
        var data = {
            user_id: ud.id,
            fav_user_id,
            delete: isDelete?1:0
        }
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        axios.post(`${SERVER_IP}/usersFavourite`, data, { withCredentials: true, headers: headers })
        .then(function (response) {
            if (response.data.error === false) {
                fetchContactList()
            }
        }).catch(function (error) {
            swal("Something Went Wrong,Please Retry")
        });
    }

    const getNetworkList = () => {
        var data = { user_id: ud.id }
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        axios.post(`${SERVER_IP}/usersNetworkList`, data, { withCredentials: true, headers: headers })
        .then(function (response) {
            if (response.data.contacts) {
                setNetwork_list(response.data.contacts);
                setFilterednetwork(response.data.contacts);
            }
        }).catch(function (error) {
            swal("Something Went Wrong,Please Retry")
        });
    }

    useEffect(() => {
        if (socket === undefined) {
            if (props.socket) {
                socket = props.socket;
                socket.on("live_users_list", function (data) {
                    setLiveuser(data.liveusers);
                    let arr = []
                    data.liveusers.forEach(element => {
                        arr.push(element.user_id)
                    });
                    setLiveuserids(arr)
                })
            }
        }
    }, [props])

    useEffect(() => {
        getNetworkList()
        fetchContactList()
    }, [])

    useEffect(() => {
        setInterval(() => {
            const emmitData = {
                error: false,
                message_status: "No record found",
                event: "GET_UNREAD_USER_LIST",
                chat_type: "",
                from_id: ud.id,
                to_id: "",
                data: []
            }
            socket.emit("B_MESSAGE_EVENT", emmitData)
        }, 1000);
    }, [])

    useEffect(() => {
        if (socket) {
            socket.on("F_MESSAGE_EVENT", (receivedData) => {
                if (receivedData.event=='GET_UNREAD_USER_LIST') {
                    setMessagecount(receivedData.data);
                }
            })
        }
    })

    const modalShowHandler = (id) => {
        const newArr = [...modalshow]
        newArr.forEach((element, index) => {
            if (element.id==id) {
                newArr.splice(index, 1)
            }
        });
        newArr.push({ id, show: true })
        setModalshow(newArr)
    }

    const modalHideHandler = (id) => {
        const newArr = [...modalshow]
        newArr.forEach((element, index) => {
            if (element.id==id) {
                newArr.splice(index, 1)
            }
        });
        newArr.push({ id, show: false })
        setModalshow(newArr)
    }

    const callInitiation = (call_type, call_format, callers) => {
        let to_calling_obj;
        if (Array.isArray(callers)) {
          to_calling_obj = { call_type, call_format, callers };
        } else {
          to_calling_obj = { call_type, call_format, callers: [callers] };
        }
        props.toCalling(to_calling_obj);
    };
    
    return (
        <>
            <div>
                <div className="xp-breadcrumbbar">
                    <div className="row">
                        <div className='w-100 px-3 d-flex justify-content-between'>
                            <h3 className="xp-page-title">Contact List</h3>
                            <span>
                                {/* <svg onClick={()=>setView({ ...view, block: true, list: false })} style={{marginRight: '20px', marginBottom: '12px', cursor: 'pointer'}} width="25" height="25" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 8C1.45 8 0.979 7.804 0.587 7.412C0.195667 7.02067 0 6.55 0 6V2C0 1.45 0.195667 0.979 0.587 0.587C0.979 0.195667 1.45 0 2 0H6C6.55 0 7.021 0.195667 7.413 0.587C7.80433 0.979 8 1.45 8 2V6C8 6.55 7.80433 7.02067 7.413 7.412C7.021 7.804 6.55 8 6 8H2ZM2 18C1.45 18 0.979 17.8043 0.587 17.413C0.195667 17.021 0 16.55 0 16V12C0 11.45 0.195667 10.979 0.587 10.587C0.979 10.1957 1.45 10 2 10H6C6.55 10 7.021 10.1957 7.413 10.587C7.80433 10.979 8 11.45 8 12V16C8 16.55 7.80433 17.021 7.413 17.413C7.021 17.8043 6.55 18 6 18H2ZM12 8C11.45 8 10.9793 7.804 10.588 7.412C10.196 7.02067 10 6.55 10 6V2C10 1.45 10.196 0.979 10.588 0.587C10.9793 0.195667 11.45 0 12 0H16C16.55 0 17.021 0.195667 17.413 0.587C17.8043 0.979 18 1.45 18 2V6C18 6.55 17.8043 7.02067 17.413 7.412C17.021 7.804 16.55 8 16 8H12ZM12 18C11.45 18 10.9793 17.8043 10.588 17.413C10.196 17.021 10 16.55 10 16V12C10 11.45 10.196 10.979 10.588 10.587C10.9793 10.1957 11.45 10 12 10H16C16.55 10 17.021 10.1957 17.413 10.587C17.8043 10.979 18 11.45 18 12V16C18 16.55 17.8043 17.021 17.413 17.413C17.021 17.8043 16.55 18 16 18H12Z" fill="black"/></svg> */}
                                <i onClick={()=>setView({ ...view, block: true, list: false })} className="fa fa-th-large" style={{marginRight: '20px', marginBottom: '10px', cursor: 'pointer'}}> </i>
                                <i className="fa-solid fa-bars" onClick={()=>setView({ ...view, block: false, list: true })} style={{cursor: 'pointer'}}></i>
                            </span>
                        </div>
                        <div className="col-md-12 col-lg-12 mt-3">
                            <div id='divider'>
                                <span onClick={()=>setSection({ ...section, allContact: true, favourite: false, myNetwork: false })} style={{border: section.allContact?'1px solid #2B343A':'1px solid #dcdcdc'}}>
                                    <img src={allcontant} className="userliusrt" alt="" /> 
                                    All Contact
                                </span>
                                <span onClick={()=>setSection({ ...section, allContact: false, favourite: true, myNetwork: false })} style={{border: section.favourite?'1px solid #2B343A':'1px solid #dcdcdc'}}>
                                    <img src={favrouite} className="userliusrt" alt="" /> 
                                    Favourite
                                </span>
                                <span onClick={()=>setSection({ ...section, allContact: false, favourite: false, myNetwork: true })} style={{border: section.myNetwork?'1px solid #2B343A':'1px solid #dcdcdc'}}>
                                    <img src={network} className="userliusrt" alt="" /> 
                                    My Network
                                </span>
                                {section.allContact &&
                                <input className="form-control" type="search" placeholder="Search" onChange={(e)=>{
                                    const result = contact_filtered.filter((element)=>element.name.toLowerCase().includes(e.target.value.toLowerCase()))
                                    setContactList(result)
                                }}/>}
                                {section.favourite &&
                                <input className="form-control" type="search" placeholder="Search" onChange={(e)=>{
                                    const result = favourite_filtered.filter((element)=>element.name.toLowerCase().includes(e.target.value.toLowerCase()))
                                    setFavourite_list(result)
                                }}/>}
                                {section.myNetwork &&
                                <input className="form-control" type="search" placeholder="Search" onChange={(e)=>{
                                    const result = network_filtered.filter((element)=>element.name.toLowerCase().includes(e.target.value.toLowerCase()))
                                    setNetwork_list(result)
                                }}/>}
                            </div>
                            {/* <div className="xp-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a onClick={() => window.location.href = "/dashboard"}><i className="icon-home"></i></a></li>
                                    <li className="breadcrumb-item active">Contact List</li>
                                </ol>
                            </div> */}
                        </div>
                    </div>
                </div>

                <div className="xp-contentbar p-30">
                    {/* All Contact */}
                    {section.allContact &&
                    <>
                        {view.block &&
                        <div className="Cont-4-inrow">
                        {contact_list.map((list, index) =>
                            <div className="cont-cont-card" key={index}>
                                <i className="fa-solid fa-star" id='favourite' style={{color: favourite.indexOf(list.login_id)==-1?'#dcdcdc':'goldenrod', marginLeft: '25px'}} onClick={()=>postFavourite(list.login_id)}></i>
                                <div className="text-center">
                                    <img className="avatar-circle mb-3" src={`${SERVER_IP}/icons/${list.profile}`} />
                                    {liveuserids.indexOf(list.login_id)>-1 ? <span className="status online"></span> : <span className="status offline"></span>}
                                    <h3 className="user-name">{list.name}</h3>
                                    <span className="user-role">{list.email}</span>
                                    <div className="text-center mt-2">
                                        <div className="xp-button">
                                            <button type="button" className="btn btn-round btn-primary" onClick={()=>setInfopopup({ show: true, data: list })}><i className="fa fa-info"></i></button>
                                            {/* <button type="button" disabled={liveuserids.indexOf(list.login_id)==-1} onClick={()=>callInitiation("INITIATE", "F_VIDEO_CALL", liveuser[liveuserids.indexOf(list.login_id)])} className="btn btn-round btn-secondary ml-2"><i className="mdi mdi-video"></i></button> */}
                                            <button type="button" disabled={liveuserids.indexOf(list.login_id)==-1} onClick={()=>callInitiation("INITIATE", "F_AUDIO_CALL", liveuser[liveuserids.indexOf(list.login_id)])} className="btn btn-round btn-success ml-2"><i className="mdi mdi-phone"></i></button>

                                            {messagecount.length==0?
                                            <button type="button" className="btn btn-round btn-info ml-2" onClick={()=>modalShowHandler(list.login_id)}><i className="mdi mdi-message-text-outline"></i></button>
                                            :messagecount.map((element, i)=>{
                                                return (
                                                <>
                                                    {element.from_user_id==list.login_id&&
                                                    <button key={i} type="button" className="btn btn-round btn-info ml-2" onClick={()=>modalShowHandler(list.login_id)}>
                                                        <i className="mdi mdi-message-text-outline"></i>
                                                        <span style={{position: 'relative', top: '-40px', left: '10px'}} className="badge badge-primary">{element.totalUnread}</span>
                                                    </button>}
                                                </>
                                                )
                                            })}

                                            {modalshow.map((element, index)=>{
                                                return (
                                                    <>
                                                        {element.id==list.login_id&&element.show&&
                                                        <div key={index} className="modal fade show" style={{display: 'block', paddingRight: '5px'}} tabIndex="-1" aria-modal="true" role="dialog">
                                                        <Chat socket={socket} data={list} setMinimizetabs={setMinimizetabs} minimizetabs={minimizetabs} modalshow={modalshow} setModalshow={setModalshow} />
                                                        </div>}
                                                    </>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        </div>}

                        {view.list &&
                        <>
                        {contact_list.map((list, index)=>{
                            return (
                            <div id='listView' key={index}>
                                <div>
                                    {liveuserids.indexOf(list.login_id)>-1 ? <span style={{position: 'relative', top: '0px', left: '0px', marginRight: '10px'}} className="status online"></span> : <span style={{position: 'relative', top: '0px', left: '0px', marginRight: '10px'}} className="status offline"></span>}
                                    <i className="fa-solid fa-star" id='favourite' style={{color: favourite.indexOf(list.login_id)==-1?'#dcdcdc':'goldenrod'}} onClick={()=>postFavourite(list.login_id)}></i>
                                    <img style={{height: '30px', width: '30px', borderRadius: '50%'}} src={`${SERVER_IP}/icons/${list.profile}`} alt="contact profile"/>
                                    <p>{list.name}&nbsp;|&nbsp;</p>
                                    <p>{list.email}</p>
                                </div>

                                <div>
                                    <button type="button" className="btn btn-round btn-primary" onClick={()=>setInfopopup({ show: true, data: list })}><i className="fa fa-info"></i></button>
                                    {/* <button type="button" disabled={liveuserids.indexOf(list.login_id)==-1} onClick={()=>callInitiation("INITIATE", "F_VIDEO_CALL", liveuser[liveuserids.indexOf(list.login_id)])} className="btn btn-round btn-secondary ml-2"><i className="mdi mdi-video"></i></button> */}
                                    <button type="button" disabled={liveuserids.indexOf(list.login_id)==-1} onClick={()=>callInitiation("INITIATE", "F_AUDIO_CALL", liveuser[liveuserids.indexOf(list.login_id)])} className="btn btn-round btn-success ml-2"><i className="mdi mdi-phone"></i></button>

                                    {messagecount.length==0?
                                    <button type="button" className="btn btn-round btn-info ml-2" onClick={()=>modalShowHandler(list.login_id)}><i className="mdi mdi-message-text-outline"></i></button>
                                    :messagecount.map((element, i)=>{
                                        return (
                                        <>
                                            {element.from_user_id==list.login_id&&
                                            <button key={i} type="button" className="btn btn-round btn-info ml-2" onClick={()=>modalShowHandler(list.login_id)}>
                                                <i className="mdi mdi-message-text-outline"></i>
                                                <span style={{position: 'relative', top: '-40px', left: '10px'}} className="badge badge-primary">{element.totalUnread}</span>
                                            </button>}
                                        </>
                                        )
                                    })}

                                    {modalshow.map((element, index)=>{
                                        return (
                                            <>
                                                {element.id==list.login_id&&element.show&&
                                                <div key={index} className="modal fade show" style={{display: 'block', paddingRight: '5px'}} tabIndex="-1" aria-modal="true" role="dialog">
                                                <Chat socket={socket} data={list} setMinimizetabs={setMinimizetabs} minimizetabs={minimizetabs} modalshow={modalshow} setModalshow={setModalshow} />
                                                </div>}
                                            </>
                                        )
                                    })}
                                </div>
                            </div>
                            )
                        })}
                        </>}
                    </>
                    }

                    {/* Favourite */}
                    {section.favourite &&
                    <>
                        {view.block &&
                        <div className="Cont-4-inrow">
                        {favourite_list.map((list, index) =>
                            <div className="cont-cont-card" key={index}>
                                <div className="text-center">
                                    <img className="avatar-circle mb-3" src={`${SERVER_IP}/icons/${list.profile}`} />
                                    {liveuserids.indexOf(list.login_id)>-1 ? <span className="status online"></span> : <span className="status offline"></span>}
                                    <h3 className="user-name">{list.name}</h3>
                                    <span className="user-role">{list.email}</span>
                                    <div className="text-center mt-2">
                                        <div className="xp-button">
                                            <button type="button" className="btn btn-round btn-primary" onClick={()=>setInfopopup({ show: true, data: list })}><i className="fa fa-info"></i></button>
                                            {/* <button type="button" disabled={liveuserids.indexOf(list.login_id)==-1} onClick={()=>callInitiation("INITIATE", "F_VIDEO_CALL", liveuser[liveuserids.indexOf(list.login_id)])} className="btn btn-round btn-secondary ml-2"><i className="mdi mdi-video"></i></button> */}
                                            <button type="button" disabled={liveuserids.indexOf(list.login_id)==-1} onClick={()=>callInitiation("INITIATE", "F_AUDIO_CALL", liveuser[liveuserids.indexOf(list.login_id)])} className="btn btn-round btn-success ml-2"><i className="mdi mdi-phone"></i></button>

                                            {messagecount.length==0?
                                            <button type="button" className="btn btn-round btn-info ml-2" onClick={()=>modalShowHandler(list.login_id)}><i className="mdi mdi-message-text-outline"></i></button>
                                            :messagecount.map((element, i)=>{
                                                return (
                                                <>
                                                    {element.from_user_id==list.login_id&&
                                                    <button key={i} type="button" className="btn btn-round btn-info ml-2" onClick={()=>modalShowHandler(list.login_id)}>
                                                        <i className="mdi mdi-message-text-outline"></i>
                                                        <span style={{position: 'relative', top: '-40px', left: '10px'}} className="badge badge-primary">{element.totalUnread}</span>
                                                    </button>}
                                                </>
                                                )
                                            })}

                                            {modalshow.map((element, index)=>{
                                                return (
                                                    <>
                                                        {element.id==list.login_id&&element.show&&
                                                        <div key={index} className="modal fade show" style={{display: 'block', paddingRight: '5px'}} tabIndex="-1" aria-modal="true" role="dialog">
                                                        <Chat socket={socket} data={list} setMinimizetabs={setMinimizetabs} minimizetabs={minimizetabs} modalshow={modalshow} setModalshow={setModalshow} />
                                                        </div>}
                                                    </>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>  
                        )}
                        </div>}

                        {view.list &&
                        <>
                        {favourite_list.map((list, index)=>{
                            return (
                            <div id='listView' key={index}>
                                <div>
                                    {liveuserids.indexOf(list.login_id)>-1 ? <span style={{position: 'relative', top: '0px', left: '0px'}} className="status online"></span> : <span style={{position: 'relative', top: '0px', left: '0px', marginRight: '10px'}} className="status offline"></span>}
                                    <img style={{height: '30px', width: '30px', borderRadius: '50%'}} src={`${SERVER_IP}/icons/${list.profile}`} alt="contact profile"/>
                                    <p>{list.name}&nbsp;|&nbsp;</p>
                                    <p>{list.email}</p>
                                </div>

                                <div>
                                    <button type="button" className="btn btn-round btn-primary" onClick={()=>setInfopopup({ show: true, data: list })}><i className="fa fa-info"></i></button>
                                    {/* <button type="button" disabled={liveuserids.indexOf(list.login_id)==-1} onClick={()=>callInitiation("INITIATE", "F_VIDEO_CALL", liveuser[liveuserids.indexOf(list.login_id)])} className="btn btn-round btn-secondary ml-2"><i className="mdi mdi-video"></i></button> */}
                                    <button type="button" disabled={liveuserids.indexOf(list.login_id)==-1} onClick={()=>callInitiation("INITIATE", "F_AUDIO_CALL", liveuser[liveuserids.indexOf(list.login_id)])} className="btn btn-round btn-success ml-2"><i className="mdi mdi-phone"></i></button>

                                    {messagecount.length==0?
                                    <button type="button" className="btn btn-round btn-info ml-2" onClick={()=>modalShowHandler(list.login_id)}><i className="mdi mdi-message-text-outline"></i></button>
                                    :messagecount.map((element, i)=>{
                                        return (
                                        <>
                                            {element.from_user_id==list.login_id&&
                                            <button key={i} type="button" className="btn btn-round btn-info ml-2" onClick={()=>modalShowHandler(list.login_id)}>
                                                <i className="mdi mdi-message-text-outline"></i>
                                                <span style={{position: 'relative', top: '-40px', left: '10px'}} className="badge badge-primary">{element.totalUnread}</span>
                                            </button>}
                                        </>
                                        )
                                    })}

                                    {modalshow.map((element, index)=>{
                                        return (
                                            <>
                                                {element.id==list.login_id&&element.show&&
                                                <div key={index} className="modal fade show" style={{display: 'block', paddingRight: '5px'}} tabIndex="-1" aria-modal="true" role="dialog">
                                                <Chat socket={socket} data={list} setMinimizetabs={setMinimizetabs} minimizetabs={minimizetabs} modalshow={modalshow} setModalshow={setModalshow} />
                                                </div>}
                                            </>
                                        )
                                    })}
                                </div>
                            </div>
                            )
                        })}
                        </>}
                    </>
                    }

                    {/* Network */}
                    {section.myNetwork &&
                    <>
                        {view.block &&
                        <div className="Cont-4-inrow">
                        {network_list.map((list, index) =>
                            <div className="cont-cont-card" key={index}>
                                <div className="text-center">
                                    <img className="avatar-circle mb-3" src={`${SERVER_IP}/icons/${list.profile}`} />
                                    {liveuserids.indexOf(list.login_id)>-1 ? <span className="status online"></span> : <span className="status offline"></span>}
                                    <h3 className="user-name">{list.name}</h3>
                                    <span className="user-role">{list.email}</span>
                                    <div className="text-center mt-2">
                                        <div className="xp-button">
                                            <button type="button" className="btn btn-round btn-primary" onClick={()=>setInfopopup({ show: true, data: list })}><i className="fa fa-info"></i></button>
                                            {/* <button type="button" disabled={liveuserids.indexOf(list.login_id)==-1} onClick={()=>callInitiation("INITIATE", "F_VIDEO_CALL", liveuser[liveuserids.indexOf(list.login_id)])} className="btn btn-round btn-secondary ml-2"><i className="mdi mdi-video"></i></button> */}
                                            <button type="button" disabled={liveuserids.indexOf(list.login_id)==-1} onClick={()=>callInitiation("INITIATE", "F_AUDIO_CALL", liveuser[liveuserids.indexOf(list.login_id)])} className="btn btn-round btn-success ml-2"><i className="mdi mdi-phone"></i></button>

                                            {messagecount.length==0?
                                            <button type="button" className="btn btn-round btn-info ml-2" onClick={()=>modalShowHandler(list.login_id)}><i className="mdi mdi-message-text-outline"></i></button>
                                            :messagecount.map((element, i)=>{
                                                return (
                                                <>
                                                    {element.from_user_id==list.login_id&&
                                                    <button key={i} type="button" className="btn btn-round btn-info ml-2" onClick={()=>modalShowHandler(list.login_id)}>
                                                        <i className="mdi mdi-message-text-outline"></i>
                                                        <span style={{position: 'relative', top: '-40px', left: '10px'}} className="badge badge-primary">{element.totalUnread}</span>
                                                    </button>}
                                                </>
                                                )
                                            })}

                                            {modalshow.map((element, index)=>{
                                                return (
                                                    <>
                                                        {element.id==list.login_id&&element.show&&
                                                        <div key={index} className="modal fade show" style={{display: 'block', paddingRight: '5px'}} tabIndex="-1" aria-modal="true" role="dialog">
                                                        <Chat socket={socket} data={list} setMinimizetabs={setMinimizetabs} minimizetabs={minimizetabs} modalshow={modalshow} setModalshow={setModalshow} />
                                                        </div>}
                                                    </>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        </div>}

                        {view.list &&
                        <>
                        {network_list.map((list, index)=>{
                            return (
                            <div id='listView' key={index}>
                                <div>
                                    {liveuserids.indexOf(list.login_id)>-1 ? <span style={{position: 'relative', top: '0px', left: '0px'}} className="status online"></span> : <span style={{position: 'relative', top: '0px', left: '0px', marginRight: '10px'}} className="status offline"></span>}
                                    <img style={{height: '30px', width: '30px', borderRadius: '50%'}} src={`${SERVER_IP}/icons/${list.profile}`} alt="contact profile"/>
                                    <p>{list.name}&nbsp;|&nbsp;</p>
                                    <p>{list.email}</p>
                                </div>

                                <div>
                                    <button type="button" className="btn btn-round btn-primary" onClick={()=>setInfopopup({ show: true, data: list })}><i className="fa fa-info"></i></button>
                                    {/* <button type="button" disabled={liveuserids.indexOf(list.login_id)==-1} onClick={()=>callInitiation("INITIATE", "F_VIDEO_CALL", liveuser[liveuserids.indexOf(list.login_id)])} className="btn btn-round btn-secondary ml-2"><i className="mdi mdi-video"></i></button> */}
                                    <button type="button" disabled={liveuserids.indexOf(list.login_id)==-1} onClick={()=>callInitiation("INITIATE", "F_AUDIO_CALL", liveuser[liveuserids.indexOf(list.login_id)])} className="btn btn-round btn-success ml-2"><i className="mdi mdi-phone"></i></button>

                                    {messagecount.length==0?
                                    <button type="button" className="btn btn-round btn-info ml-2" onClick={()=>modalShowHandler(list.login_id)}><i className="mdi mdi-message-text-outline"></i></button>
                                    :messagecount.map((element, i)=>{
                                        return (
                                        <>
                                            {element.from_user_id==list.login_id&&
                                            <button key={i} type="button" className="btn btn-round btn-info ml-2" onClick={()=>modalShowHandler(list.login_id)}>
                                                <i className="mdi mdi-message-text-outline"></i>
                                                <span style={{position: 'relative', top: '-40px', left: '10px'}} className="badge badge-primary">{element.totalUnread}</span>
                                            </button>}
                                        </>
                                        )
                                    })}

                                    {modalshow.map((element, index)=>{
                                        return (
                                            <>
                                                {element.id==list.login_id&&element.show&&
                                                <div key={index} className="modal fade show" style={{display: 'block', paddingRight: '5px'}} tabIndex="-1" aria-modal="true" role="dialog">
                                                <Chat socket={socket} data={list} setMinimizetabs={setMinimizetabs} minimizetabs={minimizetabs} modalshow={modalshow} setModalshow={setModalshow} />
                                                </div>}
                                            </>
                                        )
                                    })}
                                </div>
                            </div>
                            )
                        })}
                        </>}
                    </>
                    }

                    {/* Info Popup */}
                    {infopopup.show &&
                    <div className="contact_info">
                        <div className="c_container">
                            <div className="card">
                                <div className="card-body">
                                    <button className="btn btn-round close" onClick={()=>setInfopopup({ show: false, data: {} })}>
                                        <svg fill="#B9312F" width="30px" x="0px" y="0px" viewBox="0 0 512 512"><path d="M437.019,74.981C388.668,26.628,324.378,0,256,0C187.62,0,123.333,26.628,74.981,74.98S0,187.62,0,256c0,68.381,26.628,132.668,74.981,181.02C123.332,485.372,187.62,512,255.999,512s132.669-26.628,181.02-74.98C485.371,388.667,512,324.38,512,256C512,187.619,485.371,123.332,437.019,74.981z M368.853,347.642c5.857,5.857,5.857,15.355,0,21.213c-2.93,2.929-6.768,4.393-10.607,4.393c-3.838,0-7.678-1.465-10.605-4.393L256,277.214l-91.641,91.641c-2.93,2.929-6.768,4.393-10.607,4.393c-3.838,0-7.678-1.465-10.605-4.393c-5.858-5.857-5.858-15.355,0-21.213l91.64-91.641l-91.64-91.641c-5.858-5.857-5.858-15.355,0-21.213c5.857-5.857,15.354-5.857,21.213,0L256,234.788l91.64-91.641c5.857-5.857,15.355-5.857,21.213,0c5.857,5.857,5.857,15.355,0,21.213l-91.641,91.641L368.853,347.642z"/></svg>
                                    </button>
                                    <div className="user_info-wrapper">
                                        <div className="user_profile-pic">
                                            <img src={`${SERVER_IP}/icons/${infopopup.data.profile}`} alt="user-profile" className="avatar-circle" />
                                        </div>

                                        <div className="user_info text-left mt-3 ml-3">
                                            <h3 className="user-name text-left">{infopopup.data.name}</h3>
                                            <p>Web Designer</p>
                                            <hr />
                                            <p><strong className="mr-2">Email :</strong>{infopopup.data.email}</p>
                                            <p><strong className="mr-2">Contact No :</strong>{infopopup.data.phone}</p>
                                            <p><strong className="mr-2">Designation :</strong>Sales &amp; Marketing</p>
                                            <p><strong className="mr-2">Address :</strong>{infopopup.data.address}</p>
                                            <p><strong className="mr-2">Pincode :</strong>{infopopup.data.zip}</p>
                                            <p><strong className="mr-2">City :</strong>{infopopup.data.city}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                </div>
            </div>

            <div style={{display: 'flex', position: 'fixed', bottom: '10px', right: '10px', maxWidth: '78rem', overflowY: 'auto'}}>
                {minimizetabs.map((element, index)=>{
                    return (
                    <div key={index} style={{backgroundColor: '#B9312F', borderColor: '#B9312F', borderRadius: '3px', margin: '0 10px', minWidth: '16rem'}}>
                        {contact_list.map((list) => {
                            return (
                                list.login_id==element && <button key={index} type="button" className="btn btn-primary mx-1" onClick={()=>modalShowHandler(list.login_id)}>{list.name}</button>
                            )
                        })}
                        <button type="button" className="btn btn-round btn-primary" onClick={()=>modalShowHandler(element)}><i className="fa-solid fa-minus"></i></button>
                        <button type="button" className="btn btn-round btn-primary mx-1" onClick={()=>{
                        const newArr = [...minimizetabs]
                        newArr.splice(newArr.indexOf(element), 1)
                        setMinimizetabs(newArr)
                        }}><i className="fa-solid fa-xmark"></i></button>
                    </div>
                    )
                })}

            </div>
        </>
    )
}